<template>
  <div>
    <div class="sidemenu-mask-dropdown" @click="onFolderClick">
      <div class="tooltip-hover" :open="undefined" :title="item.data.Label">
        <i :class="['status-icon fa fa-chevron-right', isOpen ? 'open' : 'closed']"> </i>
        <i :class="getIcon(item.data) && !isFolder"></i>
        <i v-if="!isOpen" class="fa fa-folder"></i>
        <i v-if="isOpen" class="fa fa-folder-open"></i>
        {{ item.data.Label }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue'
import Constants from '../constants'

const props = defineProps({
  item: Object,
  level: Number,
  open: Boolean,
  numChildren: Number,
  sidemenu: Object,
})
const emit = defineEmits(['onOpenChange'])

const isOpen = ref(false)
onMounted(() => {
  isOpen.value = props.open
})
watch(
  () => props.open,
  (val) => {
    isOpen.value = val
  }
)

const isFolder = computed(() => Constants.menu.icon[props.item.data.IconType].value === 'fa fa-folder')
const getIcon = (menuItem) => Constants.menu.icon[menuItem.IconType].value

function onFolderClick(event) {
  event.preventDefault()
  event.stopPropagation()
  emit('onOpenChange', !isOpen.value)
}
</script>
